import type { ITicketForm } from 'views/Ticket/components/form-ticket';
import type { AdjuntoBase64 } from 'models/adjunto_base64_model';
import type { ITicket } from 'models/ticket_model';
import http from './http';

interface TicketListResponse {
  rows: ITicket[];
  count: number;
}

/**
 * Convierte una cadena base64 en un archivo
 * @param base64String
 * @param fileName
 * @param fileType
 * @returns
 */
export function base64ToFile(
  base64String: string,
  fileName: string,
  fileType: string,
) {
  // Decodifica la cadena base64
  const byteString = atob(base64String.split(',')[1]);

  // Crea un ArrayBuffer para almacenar los datos binarios
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // Crea un Blob a partir de los datos binarios
  const blob = new Blob([ab], { type: fileType });

  // Crea un archivo a partir del Blob
  return new File([blob], fileName, { type: fileType });
}

export const createTicketService = async (data: ITicketForm) => {
  const formData = new FormData();

  formData.append('subject', data.asunto);
  formData.append('description', data.descripcion);
  formData.append('location', data.location);

  // Asegúrate de que 'files' esté en formato JSON y conviértelo a un array
  let files: AdjuntoBase64[] = [];
  try {
    files = JSON.parse(data.files || '[]') as AdjuntoBase64[];
  } catch (error) {
    console.error('Error al parsear los archivos:', error);
  }

  // agregar los archivos al formData
  if (files.length > 0) {
    files.forEach((file, index) => {
      const fileObject = base64ToFile(
        file.fileObject.data,
        file.fileName,
        file.fileType,
      );
      formData.append(`files-${index}`, fileObject);
    });
  }

  try {
    return await http.post(`/ticket/`, formData, {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    });
  } catch (error) {
    console.error('Ocurrió un error al enviar el ticket:', error);
    return null;
  }
};

export const getTicketProfesorService = async () => {
  try {
    return await http.get<TicketListResponse>(`/ticket-profesor`);
  } catch (error) {
    console.error('Error al obtener los tickets del profesor:', error);
    return { rows: [], count: 0 };
  }
};

export const getTicketMonitorService = async (filtros?: {
  status?: string
}) => {
  try {
    return await http.get<TicketListResponse>(`/ticket-monitor${filtros ? `?status=${filtros.status}` : ''}`);
  } catch (error) {
    console.error('Error al obtener los tickets del monitor:', error);
    return { rows: [], count: 0 };
  }
};
